<template>
  <AtomsLoading />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useLoadingStore } from "@/store/index";

const loading = useLoadingStore();

// HTML lang + direction per locale (Arabic is RTL)
const { locale } = useI18n();
const RTL_LOCALES = ["ar"];
useHead({
  htmlAttrs: {
    lang: computed(() => locale.value),
    dir: computed(() => (RTL_LOCALES.includes(locale.value) ? "rtl" : "ltr")),
  },
});

// Sayfa ilk yüklendiğinde loading açık
loading.setLoading(true);

onMounted(() => {
  setTimeout(() => {
    loading.setLoading(false); // İlk yükleme için spinner kapanır
  }, 1000);
});
</script>
